<dojo-button
  #featureFlagMenuTrigger="matMenuTrigger"
  [matMenuTriggerFor]="featureFlagMenu"
  class="w-full"
  [class.active]="featureFlagMenuTrigger.menuOpen"
  size="s"
  [fill]="'outline'"
>
  <dojo-icon icon="flag" class="mr-2"></dojo-icon>
  <span>Feature Flags</span>
</dojo-button>

<mat-menu #featureFlagMenu="matMenu" class="feature-flag-menu">
  <ng-template matMenuContent>
    <div class="feature-flag-menu-content" (click)="$event.stopPropagation()">
      <div class="menu-header border-b border-neutral-200 px-4 py-3">
        <h3 class="text-md font-semibold text-gray-800">Feature Flags</h3>
      </div>

      <div class="menu-body scrollable-list px-4 py-2">
        @for (flag of state.featureFlags; track flag.key) {
          <div class="flag-item flex items-center justify-between gap-3 py-2">
            <span class="flag-name truncate text-sm text-gray-700" [matTooltip]="flag.key" [matTooltipShowDelay]="500">
              {{ flag.key }}
            </span>
            <ion-toggle [checked]="flag.value" (ionChange)="onFeatureFlagToggle(flag.key, $event)" />
          </div>
        }
      </div>
    </div>
  </ng-template>
</mat-menu>
